import {render as renderHtml, diff, createElement, mount} from './vdom';
import Authorization from './components/Login/Authorization';
import App from './components/App';
import airgram from './airgram';
import store from './store';

const hooks = new Map();
const renderQueue = new Set();

let currentContextComponent = null;
let currentComponentId = null;
let currentNewComponent = false;
let componentIds = 0;

function useState(initState) {
    let cachedComponent = currentContextComponent;
    if(!currentNewComponent) {
        const componentHooks = hooks.get(currentComponentId);

        return componentHooks.stack[++componentHooks.currentNumber]();
    }

    const state = initState || {};

    function path(values) {
        // console.log(cachedComponent);
        Object.entries(values).forEach(([key, value]) => {
            state[key] = value;
            // console.log(renderQueue.size);
            // cachedComponent.computeVNode();
            renderQueue.add(cachedComponent);
        });
    }

    if(!hooks.has(currentComponentId)) {
        hooks.set(currentComponentId, {
            currentNumber: 0,
            stack: [],
        })
    }

    hooks.get(currentComponentId).stack.push(() => [state, path]);
    // notResolvedHooks.get(currentComponentId).push(hook);
    return [state, path];
}

function resolveHooks(vComponent) {

}

function getComponent(fn, definition) {
    const componentName = fn.name;
    currentNewComponent = true;

    let cachedVNode = null;
    let oldVNode = null;

    const vComponent = {
        name: componentName,
        context: currentContextComponent,
        vNode: null,
        oldVNode: null,
        id: ++componentIds,
        isMounted: false,
        isComputed: false,
        cachedComponents: {},
        computeVNode: () => {
            let prevContextComponent = currentContextComponent;
            currentContextComponent = vComponent;

            // vComponent.oldVNode = cachedVNode;
            vComponent.vNode = renderFn(createVNode);

            currentContextComponent = prevContextComponent;
        }
    };

    Object.defineProperty(vComponent, 'vNode', {
        get() {
            if(!cachedVNode) {
                vComponent.computeVNode();
            }

            return cachedVNode;
        },
        set(v) {
            vComponent.oldVNode = cachedVNode;
            cachedVNode = v;
        }
    });

    let prevComponentId = currentComponentId;
    let prevContextComponent = currentContextComponent;
    currentComponentId = componentIds;
    currentContextComponent = vComponent;

    const allowedKeys = ['props', 'airgram', 'store'];
    const componentArgs = {
        airgram,
        store,
    };

    allowedKeys.forEach(key => {
        componentArgs[key] = definition[key] || componentArgs[key] || {};
    });

    const renderFn = fn.call(vComponent, componentArgs);

    currentComponentId = prevComponentId;
    currentContextComponent = prevContextComponent;

    return vComponent;
}

function createVNode(...args) {
    if(typeof args[0] === 'function') {
        // console.log('current', currentContextComponent);

        if(!currentContextComponent.cachedComponents[args[1].key]) {
            currentContextComponent.cachedComponents[args[1].key] = createComponent(...args);
        }
        // currentContextComponent.cachedComponents[args[1].key].computeVNode();

        return currentContextComponent.cachedComponents[args[1].key];
    }

    return createElement(...args);
}

function createComponent(componentFn, definition = {}) {
    const component = getComponent(componentFn, definition);
    // component.computeVNode();
    // console.log(component.id);

    return component;
}

const tick = () => {
    let likeArr = [...renderQueue];
    // console.log(likeArr.length);
    // console.log(likeArr.length)
    while (likeArr.length !== 0) {
        console.log('Render tick');
        let vComponent = likeArr.pop();
        // def();
        // console.log(def.oldVNode);

        // vComponent.oldVNode = vComponent.vNode;
        // console.log(vComponent.oldVNode);
        vComponent.computeVNode();
        // console.log(vComponent.vNode);

        const vNode = vComponent.vNode;

        // console.log(vNode, vComponent.oldVNode);
        if(!vComponent.isMounted) {
            console.log('new node');
            vComponent.rootNode = vComponent.rootNode ? vComponent.rootNode : renderHtml(vNode);
            vComponent.isMounted = true;
        }
        console.log('asdasd');

        const patch = diff(vComponent.oldVNode, vNode);
        // console.log(vComponent.parentNode);
        // vComponent.rootNode =
            patch(vComponent.rootNode);
        console.log(vComponent.rootNode);

        // if(!vComponent.isMounted) {
        //     mount(renderHtml(vNode), vNode.parent);
        //     vComponent.isMounted = true;
        // } else {
        //     const patch = diff(def.oldVNode, def.render());
        //     def.$root = patch(def.$root);
        // }

        // we might replace the whole $rootEl,
        // so we want the patch will return the new $rootEl
        renderQueue.delete(vComponent);
    }

    setTimeout(tick, 0);
};

function Test(props) {
    const [state, patch] = useState({x: 0});

    return (h) => {
        return h('div', {
            on: {
                click: () => patch({x: state.x + 1})
            },
            children: [
                h('span', {
                    children: [
                        String(state.x)
                    ]
                }),
            ]
        });
    }
}

function App1(props) {

    const [state, patch] = useState({x: 0});

    return (h) => {
        return h('div', {
            on: {
                click: () => {
                    patch({x: state.x + 1})
                }
            },
            children: [
                h('span', {
                    children: [
                        String(state.x)
                    ]
                }),
                h(Test, {key: 'test'})
            ]
        });
    }
}

function Wrapper() {
    return h => h('div', {
        children: [
            h(App, {
                key: 'app',
            }),
        ]
    })
}

const a = createComponent(Wrapper);
const $root = document.getElementById('app');
// mount(renderHtml(a.vNode), $root);


tick();
//
renderQueue.add(a);

a.rootNode = $root;

console.log(hooks);


export {
    useState,
}

export default App;
